import { Breadcrumb, Col, Row, Pagination, Table, Select, Dropdown, Menu, notification, Button, Space } from "antd";
import { ColumnsType } from "antd/lib/table";
import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import { useLazyGetListHistoryActionQuery } from "../redux/ProfileApi";
import { AuctionHistorySearch, ListResponseFile } from "../types";
import { ReactComponent as ListWait } from '../../../assets/images/list_wait.svg';
import { ReactComponent as ListSuccess } from '../../../assets/images/list_success.svg';
import { ReactComponent as ListError } from '../../../assets/images/list_error.svg';
import { ReactComponent as ListAction } from '../../../assets/images/list_action.svg';
import { ReactComponent as ListPay } from '../../../assets/images/list_pay.svg';
import AuctionHistoryFilter from "./components/AuctionHistoryFilter";
import { StartStatus } from "../../auction/types";
import { preCostTypes, registerTypes } from "../../common/types/types";
import RegisterAuction from "../../auction/online-auction/auction-list/components/RegisterAuction";
import AuctionHistoryDetail from "./components/AuctionHistoryDetail";
import PrepayModal from "../../common/components/PrepayModal";
import ConfirmModal from "../../common/components/ConfirmModal";
import { useRefuseBidMutation } from "../../../redux/api/BidApi";
import { exportFile } from "../../common/ts/CommonFunctions";
import { format } from "date-fns";

interface AuctionHistoryTable {
    key: number,
    identityCode: string,
    property: {
        name: string,
        id: number,
        preCost: number,
        startAuctionDateStr: string,
        statuteId: number,
        anotherCost: number,
    },
    createdDate: string,
    registerStatus: number,
    registerStatusStr: string,
    preCostStatus: number,
    preCostStatusStr: string,
    startStatus: number,
    startStatusStr: string,
    bidderId: number,
    files: ListResponseFile[],
    note: string,
}

const registerStatusIcon: Record<number, { icon: React.ReactNode, title: string }> = {
    0: { icon: <ListWait />, title: "Đã nộp hồ sơ" },
    1: { icon: <ListSuccess />, title: "Thành công" },
    2: { icon: <ListError />, title: "Từ chối tham gia" },
    3: { icon: <ListError />, title: "Không hợp lệ" },
}

const { Option } = Select;

const AuctionHistoryList = () => {
    const [trigger, response] = useLazyGetListHistoryActionQuery();
    const [refuseBid] = useRefuseBidMutation();

    const [submitValue, setSubmitValue] = useState<AuctionHistorySearch>();
    const [size, setPageSize] = useState(10);
    const [page, setPage] = useState(1);
    const [auctionHistoryList, setAuctionHistoryList] = useState<AuctionHistoryTable[]>([]);
    const [registerVisible, setRegisterVisible] = useState(false);
    const [prepayVisible, setPrepayVisible] = useState(false);
    const [detailVisible, setDetailVisible] = useState(false);
    const [declineVisible, setDeclineVisible] = useState(false);

    const [productId, setProductId] = useState(0);
    const [statuteId, setStatuteId] = useState(0);
    const [bidderId, setBidderId] = useState(0);
    const [productName, setProductName] = useState("");
    const [preCost, setPreCost] = useState(0);
    const [anotherCost, setAnotherCost] = useState(0);
    const [startAuctionDate, setStartAuctionDate] = useState("");

    const divRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        trigger({
            page: 0,
            size: 10
        })
    }, [trigger])

    useEffect(() => {
        let newList: AuctionHistoryTable[] = [];
        newList = response.data?.content ? response.data?.content?.map((item, index) => {
            let startStatusStr = "";
            switch (item.product.startStatus) {
                case StartStatus.UPCOMING:
                    startStatusStr = "Sắp diễn ra";
                    break;
                case StartStatus.ONGOING:
                    startStatusStr = "Đang diễn ra";
                    break;
                case StartStatus.PAUSE:
                    startStatusStr = "Đang tạm dừng";
                    break;
                case StartStatus.FINISH:
                    startStatusStr = "Đã kết thúc";
                    break;
                default:
                    startStatusStr = "Sắp diễn ra";
                    break;
            }

            return {
                key: index,
                createdDate: format(item.createdDate, "dd/MM/yyyy HH:mm:ss"),
                stattuteCode: item.statuteOfBidder?.code || "-",
                identityCode: item.identityCode || "-",
                preCostStatus: item.preCostStatus,
                preCostStatusStr: item.preCostStatusStr,
                property: {
                    id: item.product.productId,
                    name: item.product.productName,
                    preCost: item.product.preCost,
                    startAuctionDateStr: item.product.startAuctionDateStr || "",
                    statuteId: item.product.statute.statuteId,
                    anotherCost: item.product.anotherCost || 0,
                },
                registerStatus: item.registerStatus,
                registerStatusStr: item.registerStatusStr,
                startStatus: item.product.startStatus,
                startStatusStr,
                bidderId: item.bidderId,
                files: item.files,
                note: item.note || "",
            }
        }) : [];
        setAuctionHistoryList(newList);
        scrollToStart();
    }, [response])

    const triggerSearch = (currentSubmitValue: AuctionHistorySearch) => {
        trigger({
            page: page - 1,
            size,
            ...(currentSubmitValue || submitValue),
        })
    }

    const preCostTableColumns: ColumnsType<AuctionHistoryTable> = [
        {
            title: 'STT',
            dataIndex: 'stt',
            key: 'stt',
            width: 70,
            align: 'center',
            render: (value, record, index) => {
                return (<span
                    style={{ border: '1px solid black', padding: '7px 13px', borderRadius: '20px', fontWeight: 'bold', whiteSpace: 'nowrap' }}
                    key={index}>
                    {(page - 1) * size + index + 1}
                </span>)
            }
        },
        {
            title: 'Xử lý',
            key: 'action',
            width: 60,
            align: 'center',
            render: (value, record, index) => {
                return (
                    // <div className="cursor-pointer">
                    //     <ListAction />
                    // </div>
                    <Dropdown overlay={() => renderActionButtons(record)} className="cursor-pointer">
                        <ListAction />
                    </Dropdown>
                )
            }
        },
        {
            title: "Mã quy chế",
            dataIndex: "stattuteCode",
            key: "stattuteCode",
        },
        {
            title: "Tài sản",
            dataIndex: "property",
            key: "property",
            render: (value) => {
                return (<Link to={`/auction-item/${value.id}/${value.statuteId}`}>
                    <span className="anchor-text">{value.name || ""}</span>
                </Link>)
            }
        },
        {
            title: "Ngày đăng ký",
            dataIndex: "createdDate",
            key: 'createdDate',
        },
        {
            title: "Trạng thái đấu giá",
            dataIndex: "startStatusStr",
            key: 'startStatusStr',
        },
        {
            title: 'Trạng thái đăng ký',
            dataIndex: 'registerStatus',
            key: 'registerStatus',
            render: (value: number) => {
                return (<div style={{ display: 'flex', alignItems: 'center' }}>
                    {registerStatusIcon[value]?.icon || <></>}<span style={{ marginLeft: 5 }}>{registerStatusIcon[value]?.title || ""}</span>
                </div>)
            }
        },
        {
            title: "Trạng thái tiền đặt trước",
            dataIndex: "preCostStatusStr",
            key: 'preCostStatusStr'
        },
        {
            title: 'Mã định danh',
            dataIndex: 'identityCode',
            key: 'identityCode',
        },
        {
            title: "Biên bản",
            key: 'files',
            dataIndex: 'files',
            ellipsis: true,
            render: (value: ListResponseFile[]) => {
                if (value?.[0]?.fileName && value?.[0]?.fileUrl) {
                    return (
                        <span className="anchor-text" onClick={() => downloadFile(value?.[0]?.fileUrl, value?.[0]?.fileName)}>{value?.[0]?.fileName || ""}</span>
                    )
                }

                return <></>;
            }
        },
        {
            title: "Ghi chú",
            dataIndex: "note",
            key: 'note',
        }
    ]

    const renderActionButtons = (record: AuctionHistoryTable) => {
        let buttons = { pay: false, decline: false, register: false };
        const { startStatus, registerStatus, preCostStatus } = record;
        if (startStatus === StartStatus.UPCOMING) {
            // if ((preCostStatus !== preCostTypes.NOTPAY && registerStatus !== registerTypes.DENY && registerStatus !== registerTypes.INVALID) ||
            //     (registerStatus === registerTypes.SUCCESS && preCostStatus === preCostTypes.NOTPAY)) {
            if ((registerStatus === registerTypes.SUCCESS && preCostStatus === preCostTypes.DONE) ||
                (registerStatus === registerTypes.SUBMIT && preCostStatus !== preCostTypes.NOTPAY)) {
                buttons.decline = true;
            }
            if (preCostStatus === preCostTypes.NOTPAY && registerStatus !== registerTypes.DENY && registerStatus !== registerTypes.INVALID) {
                buttons.pay = true;
            }
            if ((registerStatus === registerTypes.DENY || registerStatus === registerTypes.INVALID) && startStatus) {
                buttons.register = true;
            }
        }

        let menu = (
            <Menu className="custom-list-dropdown">
                <Menu.Item icon={<ListSuccess />} onClick={() => openDetailModal(record.bidderId)} key="detail">
                    Chi tiết
                </Menu.Item>
                {buttons.register ?
                    <Menu.Item icon={<ListSuccess />} onClick={() => openRegisterModal(record.property.id, record.property.statuteId)} key="register">
                        Đăng ký
                    </Menu.Item> : <></>}
                {buttons.decline ?
                    <Menu.Item icon={<ListError />} onClick={() => openDeclineModal(record)} key="decline">
                        Từ chối tham gia
                    </Menu.Item> : <></>}
                {buttons.pay ?
                    <Menu.Item icon={<ListPay />} onClick={() => openPrepayModal(record)} key="pay">
                        Thanh toán
                    </Menu.Item> : <></>}
            </Menu>
        )
        return menu
    }

    const scrollToStart = () => {
        if (divRef.current) {
            divRef.current.scrollIntoView({ behavior: 'smooth' })
        }
    }

    const onPageSizeChange = (currentSize: number) => {
        setPageSize(currentSize);
        setPage(1);
        triggerSearch({
            ...submitValue,
            page: 0,
            size: currentSize,
        })
    }

    const onPageChange = (currentPage: number) => {
        setPage(currentPage);
        triggerSearch({
            ...submitValue,
            page: currentPage - 1,
        })
    }

    const openRegisterModal = (id: number, statuteId: number) => {
        setProductId(id);
        setStatuteId(statuteId);
        toggleRegisterModal();
    }

    const toggleRegisterModal = () => {
        setRegisterVisible(!registerVisible);
    }

    const openDetailModal = (id: number) => {
        setBidderId(id);
        toggleDetailModal();
    }

    const toggleDetailModal = () => {
        setDetailVisible(!detailVisible);
    }

    const openPrepayModal = (record: AuctionHistoryTable) => {
        setProductId(record.property.id);
        setStatuteId(record.property.statuteId);
        setProductName(record.property.name);
        setPreCost(record.property.preCost);
        setAnotherCost(record.property.anotherCost);
        togglePrepayModal();
    }

    const togglePrepayModal = () => {
        if (prepayVisible) {
            trigger({
                ...submitValue,
                page: page - 1,
                size,
            })
        }
        setPrepayVisible(!prepayVisible);
    }

    const openDeclineModal = (record: AuctionHistoryTable) => {
        setBidderId(record.bidderId);
        setProductName(record.property.name);
        setStartAuctionDate(record.property.startAuctionDateStr);
        toggleDeclineModal();
    }

    const toggleDeclineModal = () => {
        setDeclineVisible(!declineVisible);
    }

    const onDeclineClick = () => {
        refuseBid(bidderId).unwrap().then(() => {
            notification.success({
                message: "Từ chối tham gia đấu giá thành công!"
            });
            toggleDeclineModal();
            triggerSearch({
                ...submitValue,
                page: page - 1,
                size,
            })
        }).catch(err => {
            notification.error({
                message: err.data?.message || "Từ chối tham gia đấu giá thất bại"
            })
        })
    }

    const downloadFile = (url: string, fileName: string) => {
        exportFile(url, fileName);
    }

    const exportExcel = () => {
        let filename = `${format(new Date(), "dd-MM-yyyy")}_Lịch sử tham gia đấu giá.xlsx`;
        let url = process.env.REACT_APP_API_URL + `/product/auction-register/export-list-history-action?page=0&properties=modifiedDate&size=10000&sortBy=DESC`;

        if (submitValue && Object.keys(submitValue).length) {
            Object.entries(submitValue).forEach((item) => {
                if (item[1]) {
                    url += `&${item[0]}=${item[1]}`;
                }
            })
        }

        exportFile(url, filename);
    }

    return (
        <div
            ref={divRef}
            style={{
                padding: '40px calc((100vw - 1440px) / 2) 40px',
                background: "#ececec",
                display: 'flex',
                // alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'column',
                width: '100%'
            }}
        >
            <Space style={{ display: 'flex', alignItems: 'center', marginBottom: 20 }} className="responsive-padding-1440">
                <Breadcrumb separator="  " className="custom-breadcrumb">
                    <Breadcrumb.Item>
                        <Link to="/">
                            Trang chủ
                        </Link>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item>
                        Lịch sử tham gia đấu giá
                    </Breadcrumb.Item>
                </Breadcrumb>
                <div className="responsive-title">Lịch sử tham gia đấu giá</div>
            </Space>

            {/* <div className="font-size-28 font-bold responsive-padding-1440" style={{ paddingTop: 25 }}>Lịch sử tham gia đấu giá</div> */}
            <Row gutter={30} className="responsive-padding-1440" style={{ width: '100%' }}>
                <Col span={6}>
                    <AuctionHistoryFilter setSubmitValue={setSubmitValue} triggerSearch={triggerSearch} />
                </Col>
                <Col span={18}>
                    <Row justify="space-between" align="middle" style={{ whiteSpace: 'pre-wrap' }} className="product-list-filter">
                        <span>Tổng số <strong>{response.data?.totalElements || 0}</strong> kết quả</span>
                        <Button
                            onClick={exportExcel}
                            className="button-light-yellow"
                            style={{ padding: '11px 22px', display: 'flex', alignItems: 'center' }}>Xuất dữ liệu</Button>
                    </Row>

                    <div className='custom-table-wrapper'>
                        <Table
                            loading={response.isLoading || response.isFetching}
                            columns={preCostTableColumns}
                            dataSource={auctionHistoryList}
                            pagination={false}
                        />
                    </div>

                    <Row justify="end" align="middle" style={{ marginTop: 35 }}>
                        <Select className="left-arrow-select" defaultValue={10} value={size} onChange={onPageSizeChange} dropdownStyle={{ borderRadius: 15 }}>
                            <Option value={10}>10</Option>
                            <Option value={20}>20</Option>
                            <Option value={50}>50</Option>
                            <Option value={100}>100</Option>
                        </Select>
                        <div style={{ marginRight: 20, marginLeft: 8, fontSize: 14 }}>Bản ghi</div>
                        <Pagination
                            defaultCurrent={1}
                            total={response.data?.totalElements || 0}
                            defaultPageSize={10}
                            pageSize={size}
                            className="custom-pagination"
                            current={page}
                            onChange={onPageChange}
                            showSizeChanger={false}
                        />
                    </Row>
                </Col>
            </Row>

            {registerVisible ? <RegisterAuction
                visible={registerVisible}
                itemId={productId || 0}
                statuteId={statuteId || 0}
                toggleModal={toggleRegisterModal}
                onSuccess={() => {
                    setPage(1);
                    triggerSearch({
                        ...submitValue,
                        page: 0,
                        size,
                    })
                }}
            /> : <></>}
            {detailVisible ? <AuctionHistoryDetail
                visible={detailVisible}
                bidderId={bidderId || 0}
                toggleModal={toggleDetailModal}
            /> : <></>}

            {prepayVisible ? <PrepayModal
                visible={prepayVisible}
                productId={productId}
                productName={productName}
                preCost={preCost + anotherCost}
                statuteId={statuteId}
                toggleModal={togglePrepayModal}
                onSuccess={() => {
                    setPage(1);
                    triggerSearch({
                        ...submitValue,
                        page: 0,
                        size,
                    })
                }}
            /> : <></>}

            {declineVisible ?
                <ConfirmModal
                    onCancel={toggleDeclineModal}
                    onOk={onDeclineClick}
                    okText="Đồng ý"
                    cancelText="Huỷ bỏ"
                    status="error"
                    title={<>
                        <div>Bạn có chắc chắn muốn từ chối đăng ký tham gia đấu giá tài sản?</div>
                        <div style={{ marginTop: 30 }} className='font-bold'>{`Tài sản ${productName}`}</div>
                        <div className="font-bold"><span style={{ marginRight: 20 }}>Thời gian đấu giá</span>{startAuctionDate}</div>
                    </>}
                    visible={declineVisible}
                />
                : <></>}
        </div>
    )
}

export default AuctionHistoryList